<template>
  <pictures-layout
    :resource="resource"
    :editing="editing"
    :privateType="$attrs.privateType"
    ref="CommonPicturesLayout"
  />
</template>

<script>
import PicturesLayout from "@/components/pictures/CommonPicturesLayout";
import { mapGetters } from "vuex";
import { bus } from "@/components/spaces/bus.js";

export default {
  name: "PicturesModal",
  components: { PicturesLayout },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  data() {
    return {
      editing: false,
      resource: undefined,
    };
  },
  async created() {
    this.resource = this.$attrs.resource;
  },
  mounted() {
    bus.register({
      v: this,
      switchingBehavior: "flip",
      type: `${this.$attrs.privateType ? "t_" : ""}pictures`,
    });

    bus.$on("saving-complete", resource => {
      this.resource = resource.data;
    });
  },
  methods: {
    edit() {
      this.editing = true;
    },
    cancel() {
      this.editing = false;
    },
  },
  beforeDestroy() {
    bus.$off();
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/bulma_overrides.scss";
@import "@/assets/scss/pinterestLayout.scss";
</style>
